import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface StreetSummaryDialogData {
  streetName: string;
  suburbName: string;
  roadType: string | null;
  houseCount: number;
}

export interface StreetSummaryDialogResult {
  action: 'viewStreetInfo';
}

@Component({
  selector: 'app-street-summary-dialog',
  templateUrl: './street-summary-dialog.component.html',
  styleUrls: ['./street-summary-dialog.component.css'],
})
export class StreetSummaryDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: StreetSummaryDialogData,
    private dialogRef: MatDialogRef<StreetSummaryDialogComponent, StreetSummaryDialogResult>
  ) {}

  viewStreetInfo(): void {
    this.dialogRef.close({ action: 'viewStreetInfo' });
  }
}
